module.exports = "/images/error.svg?e545d52c49d2a360c85a32ea6be999d7";